import type { ReactNode } from "react";
import { useContainerEventsSubscription } from "../api/queries";
import { EntitlementBanner } from "../features/billing/EntitlementBanner";
import { FleetProvider, useFleet } from "../fleet/FleetContext";
import { NavSidebar } from "./NavSidebar";
import { TopBar } from "./TopBar";
import "./shell.css";

function ShellLayout({ children }: { children: ReactNode }) {
  const { currentId } = useFleet();
  // Charter P-1: this is the one place the shell subscribes to the (today:
  // simulated) container event stream for the active fleet. Every
  // list/detail view underneath reads from the same react-query cache this
  // patches, so they update live without any view polling on its own.
  useContainerEventsSubscription(currentId);

  return (
    <div className="shell">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <TopBar />
      <EntitlementBanner />
      <div className="shell__body">
        <NavSidebar />
        <main className="shell__content" id="main-content" tabIndex={-1}>
          {children}
        </main>
      </div>
    </div>
  );
}

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <FleetProvider>
      <ShellLayout>{children}</ShellLayout>
    </FleetProvider>
  );
}
